import { createSlice } from '@reduxjs/toolkit'



export const counterSlice = createSlice({
    name: 'web3',
    initialState: {
        provider: null,
        address: false,
        signer: null,
        web3Modal: null,
        connected: false,
        eegtokenInstance: null,
        subscribeInstance: null,
        // Chain the wallet is actually on (registry id) and whether the app
        // supports it — see config/chains.js.
        chainId: null,
        unsupportedChain: false,
        // 'evm' (MetaMask, XDCPay, WalletConnect...) or 'solana' (Phantom, Solflare...).
        // A Solana connection has provider === null: it signs through `signer`.
        family: 'evm'

    },
    reducers: {
        clearWeb3: (state, action) => {
            state.provider = null
            state.address = false
            state.signer = null
            state.web3Modal = null
            state.connected = false
            // BUG-52 fix: these are ethers Contract instances bound to the
            // PREVIOUS wallet's signer (see setWeb3 below). Leaving them in
            // state after disconnect/switch meant any code that read them
            // straight from Redux — instead of waiting for a fresh
            // connectWallet() — could keep signing/reading with the old
            // wallet's contract instances even though `connected` was false.
            state.eegtokenInstance = null
            state.subscribeInstance = null
            state.chainId = null
            state.unsupportedChain = false
            state.family = 'evm'
        },
        setWeb3: (state, action) => {
            state.provider = action.payload.provider
            state.address = action.payload.address
            state.signer = action.payload.signer
            state.web3Modal = action.payload.web3Modal
            state.eegtokenInstance = action.payload.eegtokenInstance
            state.subscribeInstance = action.payload.subscribeInstance
            state.chainId = action.payload.chainId || null
            state.unsupportedChain = false
            state.family = action.payload.family || 'evm'
            state.connected = true


        },
        // Wallet moved to a network the app doesn't support: keep the
        // session but flag it so the UI can prompt, and drop the contract
        // instances (they belong to the previous chain).
        setUnsupportedChain: (state, action) => {
            state.chainId = action.payload
            state.unsupportedChain = true
            state.eegtokenInstance = null
            state.subscribeInstance = null
        },

    },
})

export const { clearWeb3, setWeb3, setUnsupportedChain } = counterSlice.actions



export default counterSlice.reducer